var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// ../../utilities/dom/dist/index.mjs
var dataAttr = (guard) => {
  return guard ? "" : void 0;
};
var matchAttr = (el) => {
  return {
    get: (key) => el.getAttribute(key),
    set: (key, value) => el.setAttribute(key, value),
    is: (key, value) => {
      return el.getAttribute(key) === value;
    }
  };
};
function getStyleCache() {
  ;
  globalThis.__styleCache__ = globalThis.__styleCache__ || /* @__PURE__ */ new WeakMap();
  return globalThis.__styleCache__;
}
function getComputedStyle2(el) {
  var _a;
  if (!el)
    return {};
  const cache = getStyleCache();
  let style = cache.get(el);
  if (!style) {
    const win = (_a = el == null ? void 0 : el.ownerDocument.defaultView) != null ? _a : window;
    style = win.getComputedStyle(el);
    cache.set(el, style);
  }
  return style;
}
function copyVisualStyles(fromEl, toEl) {
  if (!fromEl)
    return;
  const el = getComputedStyle2(fromEl);
  const cssText = "box-sizing:" + el.boxSizing + ";border-left:" + el.borderLeftWidth + " solid red;border-right:" + el.borderRightWidth + " solid red;font-family:" + el.fontFamily + ";font-feature-settings:" + el.fontFeatureSettings + ";font-kerning:" + el.fontKerning + ";font-size:" + el.fontSize + ";font-stretch:" + el.fontStretch + ";font-style:" + el.fontStyle + ";font-variant:" + el.fontVariant + ";font-variant-caps:" + el.fontVariantCaps + ";font-variant-ligatures:" + el.fontVariantLigatures + ";font-variant-numeric:" + el.fontVariantNumeric + ";font-weight:" + el.fontWeight + ";letter-spacing:" + el.letterSpacing + ";margin-left:" + el.marginLeft + ";margin-right:" + el.marginRight + ";padding-left:" + el.paddingLeft + ";padding-right:" + el.paddingRight + ";text-indent:" + el.textIndent + ";text-transform:" + el.textTransform;
  toEl.style.cssText += cssText;
}
function nextTick(fn) {
  const set = /* @__PURE__ */ new Set();
  function raf2(fn2) {
    const id = globalThis.requestAnimationFrame(fn2);
    set.add(() => globalThis.cancelAnimationFrame(id));
  }
  raf2(() => raf2(fn));
  return function cleanup() {
    set.forEach(function(fn2) {
      fn2();
    });
  };
}
function raf(fn) {
  const id = globalThis.requestAnimationFrame(fn);
  return function cleanup() {
    globalThis.cancelAnimationFrame(id);
  };
}
function createGhostElement(doc) {
  var el = doc.createElement("div");
  el.id = "ghost";
  el.style.cssText = "display:inline-block;height:0;overflow:hidden;position:absolute;top:0;visibility:hidden;white-space:nowrap;";
  doc.body.appendChild(el);
  return el;
}
function autoResizeInput(input) {
  var _a;
  if (!input)
    return;
  const doc = (_a = input.ownerDocument) != null ? _a : document;
  const ghost = createGhostElement(doc);
  copyVisualStyles(input, ghost);
  function resize() {
    raf(() => {
      ghost.innerHTML = input.value;
      const rect = getComputedStyle(ghost);
      input == null ? void 0 : input.style.setProperty("width", rect.width);
    });
  }
  resize();
  input == null ? void 0 : input.addEventListener("input", resize);
  input == null ? void 0 : input.addEventListener("change", resize);
  return () => {
    doc.body.removeChild(ghost);
    input == null ? void 0 : input.removeEventListener("input", resize);
    input == null ? void 0 : input.removeEventListener("change", resize);
  };
}
function getOwnerWindow(el) {
  var _a;
  return (_a = el == null ? void 0 : el.ownerDocument.defaultView) != null ? _a : window;
}
function getDescriptor(el, options) {
  var _a;
  const { type, property } = options;
  const win = getOwnerWindow(el);
  const _type = type === "input" ? "HTMLInputElement" : "HTMLTextAreaElement";
  const proto = win[_type].prototype;
  return (_a = Object.getOwnPropertyDescriptor(proto, property)) != null ? _a : {};
}
function dispatchInputValueEvent(el, value) {
  var _a;
  const win = getOwnerWindow(el);
  if (!(el instanceof win.HTMLInputElement))
    return;
  const desc = getDescriptor(el, { type: "input", property: "value" });
  (_a = desc.set) == null ? void 0 : _a.call(el, value);
  const event = new win.Event("input", { bubbles: true });
  el.dispatchEvent(event);
}
function getNativeEvent(event) {
  var _a;
  return (_a = event.nativeEvent) != null ? _a : event;
}
function validateBlur(event, opts) {
  var _a;
  const exclude = Array.isArray(opts.exclude) ? opts.exclude : [opts.exclude];
  const relatedTarget = (_a = event.relatedTarget) != null ? _a : opts.fallback;
  return exclude.every((el) => !(el == null ? void 0 : el.contains(relatedTarget)));
}
function getClosestFormElement(el) {
  if (isFormElement(el))
    return el.form;
  else
    return el.closest("form");
}
function isFormElement(el) {
  return ["textarea", "input", "select", "button"].includes(el.localName);
}
function trackFormReset(el, callback) {
  if (!el)
    return;
  const form = getClosestFormElement(el);
  form == null ? void 0 : form.addEventListener("reset", callback, { passive: true });
  return () => {
    form == null ? void 0 : form.removeEventListener("reset", callback);
  };
}
var rtlKeyMap = {
  ArrowLeft: "ArrowRight",
  ArrowRight: "ArrowLeft",
  Home: "End",
  End: "Home"
};
var sameKeyMap = {
  Up: "ArrowUp",
  Down: "ArrowDown",
  Esc: "Escape",
  " ": "Space",
  ",": "Comma",
  Left: "ArrowLeft",
  Right: "ArrowRight"
};
function getEventKey(event, options = {}) {
  var _a;
  const { dir = "ltr", orientation = "horizontal" } = options;
  let { key } = event;
  key = (_a = sameKeyMap[key]) != null ? _a : key;
  const isRtl = dir === "rtl" && orientation === "horizontal";
  if (isRtl && key in rtlKeyMap) {
    key = rtlKeyMap[key];
  }
  return key;
}
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
function setVisuallyHidden(el) {
  Object.assign(el.style, visuallyHiddenStyle);
}
function createLiveRegion(opts = {}) {
  var _a;
  const { level = "polite", document: doc = document, root, delay: _delay = 0 } = opts;
  const win = (_a = doc.defaultView) != null ? _a : window;
  const parent = root != null ? root : doc.body;
  function announce(message, delay) {
    const oldRegion = doc.getElementById("__live-region__");
    oldRegion == null ? void 0 : oldRegion.remove();
    delay = delay != null ? delay : _delay;
    const region = doc.createElement("span");
    region.id = "__live-region__";
    region.dataset.liveAnnouncer = "true";
    const role = level !== "assertive" ? "status" : "alert";
    region.setAttribute("aria-live", level);
    region.setAttribute("role", role);
    setVisuallyHidden(region);
    parent.appendChild(region);
    win.setTimeout(() => {
      region.textContent = message;
    }, delay);
  }
  function destroy() {
    const oldRegion = doc.getElementById("__live-region__");
    oldRegion == null ? void 0 : oldRegion.remove();
  }
  return { announce, destroy };
}
function queryAll(root, selector) {
  var _a;
  return Array.from((_a = root == null ? void 0 : root.querySelectorAll(selector)) != null ? _a : []);
}
function itemById(v, id) {
  return v.find((node) => node.id === id);
}
function indexOfId(v, id) {
  const item = itemById(v, id);
  return item ? v.indexOf(item) : -1;
}
function nextById(v, id, loop = true) {
  let idx = indexOfId(v, id);
  idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
  return v[idx];
}
function prevById(v, id, loop = true) {
  let idx = indexOfId(v, id);
  if (idx === -1)
    return loop ? v[v.length - 1] : null;
  idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
  return v[idx];
}
var getValueText = (item) => {
  var _a, _b;
  return (_b = (_a = item.dataset.valuetext) != null ? _a : item.textContent) != null ? _b : "";
};
var match = (valueText, query2) => valueText.toLowerCase().startsWith(query2.toLowerCase());
var wrap = (v, idx) => {
  return v.map((_, index) => v[(Math.max(idx, 0) + index) % v.length]);
};
function findByText(v, text, currentId) {
  const index = currentId ? indexOfId(v, currentId) : -1;
  let items = currentId ? wrap(v, index) : v;
  const isSingleKey = text.length === 1;
  if (isSingleKey) {
    items = items.filter((item) => item.id !== currentId);
  }
  return items.find((item) => match(getValueText(item), text));
}
function findByTypeahead(_items, options) {
  const { state: state2, activeId, key, timeout = 350 } = options;
  const search = state2.keysSoFar + key;
  const isRepeated = search.length > 1 && Array.from(search).every((char) => char === search[0]);
  const query2 = isRepeated ? search[0] : search;
  let items = _items.slice();
  const next = findByText(items, query2, activeId);
  function cleanup() {
    clearTimeout(state2.timer);
    state2.timer = -1;
  }
  function update(value) {
    state2.keysSoFar = value;
    cleanup();
    if (value !== "") {
      state2.timer = +setTimeout(() => {
        update("");
        cleanup();
      }, timeout);
    }
  }
  update(search);
  return next;
}
findByTypeahead.defaultOptions = {
  keysSoFar: "",
  timer: -1
};

// ../../types/dist/index.mjs
function createNormalizer(fn) {
  return { button: fn, label: fn, input: fn, output: fn, element: fn };
}
var normalizeProp = createNormalizer((v) => v);

// src/tags-input.dom.ts
var dom = {
  getDoc: (ctx) => {
    var _a;
    return (_a = ctx.doc) != null ? _a : document;
  },
  getRootNode: (ctx) => {
    var _a;
    return (_a = ctx.rootNode) != null ? _a : dom.getDoc(ctx);
  },
  getRootId: (ctx) => {
    var _a, _b;
    return (_b = (_a = ctx.ids) == null ? void 0 : _a.root) != null ? _b : `tags-input:${ctx.uid}`;
  },
  getInputId: (ctx) => {
    var _a, _b;
    return (_b = (_a = ctx.ids) == null ? void 0 : _a.input) != null ? _b : `tags-input:${ctx.uid}:input`;
  },
  getClearButtonId: (ctx) => {
    var _a, _b;
    return (_b = (_a = ctx.ids) == null ? void 0 : _a.clearBtn) != null ? _b : `tags-input:${ctx.uid}:clear-btn`;
  },
  getHiddenInputId: (ctx) => `tags-input:${ctx.uid}:hidden-input`,
  getLabelId: (ctx) => {
    var _a, _b;
    return (_b = (_a = ctx.ids) == null ? void 0 : _a.label) != null ? _b : `tags-input:${ctx.uid}:label`;
  },
  getControlId: (ctx) => {
    var _a, _b;
    return (_b = (_a = ctx.ids) == null ? void 0 : _a.control) != null ? _b : `tags-input:${ctx.uid}:control`;
  },
  getTagId: (ctx, opt) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = ctx.ids) == null ? void 0 : _a.tag) == null ? void 0 : _b.call(_a, opt)) != null ? _c : `tags-input:${ctx.uid}:tag:${opt.value}:${opt.index}`;
  },
  getTagDeleteBtnId: (ctx, opt) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = ctx.ids) == null ? void 0 : _a.tagDeleteBtn) == null ? void 0 : _b.call(_a, opt)) != null ? _c : `${dom.getTagId(ctx, opt)}:delete-btn`;
  },
  getTagInputId: (ctx, opt) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = ctx.ids) == null ? void 0 : _a.tagInput) == null ? void 0 : _b.call(_a, opt)) != null ? _c : `${dom.getTagId(ctx, opt)}:input`;
  },
  getEditInputId: (ctx) => `${ctx.editedId}:input`,
  getTagInputEl: (ctx, opt) => dom.getRootNode(ctx).getElementById(dom.getTagInputId(ctx, opt)),
  getRootEl: (ctx) => dom.getRootNode(ctx).getElementById(dom.getRootId(ctx)),
  getInputEl: (ctx) => dom.getRootNode(ctx).getElementById(dom.getInputId(ctx)),
  getHiddenInputEl: (ctx) => dom.getRootNode(ctx).getElementById(dom.getHiddenInputId(ctx)),
  getEditInputEl: (ctx) => dom.getRootNode(ctx).getElementById(dom.getEditInputId(ctx)),
  getElements: (ctx) => queryAll(dom.getRootEl(ctx), `[data-part=tag]:not([data-disabled])`),
  getFirstEl: (ctx) => dom.getElements(ctx)[0],
  getLastEl: (ctx) => dom.getElements(ctx)[dom.getElements(ctx).length - 1],
  getPrevEl: (ctx, id) => prevById(dom.getElements(ctx), id, false),
  getNextEl: (ctx, id) => nextById(dom.getElements(ctx), id, false),
  getElAtIndex: (ctx, index) => dom.getElements(ctx)[index],
  getIndexOfId: (ctx, id) => indexOfId(dom.getElements(ctx), id),
  isInputFocused: (ctx) => dom.getDoc(ctx).activeElement === dom.getInputEl(ctx),
  getFocusedTagValue: (ctx) => {
    var _a;
    if (!ctx.focusedId)
      return null;
    const idx = dom.getIndexOfId(ctx, ctx.focusedId);
    if (idx === -1)
      return null;
    return (_a = dom.getElements(ctx)[idx].dataset.value) != null ? _a : null;
  },
  setHoverIntent: (el) => {
    const tag = el.closest("[data-part=tag]");
    if (!tag)
      return;
    tag.dataset.deleteIntent = "";
  },
  clearHoverIntent: (el) => {
    const tag = el.closest("[data-part=tag]");
    if (!tag)
      return;
    delete tag.dataset.deleteIntent;
  },
  dispatchInputEvent(ctx) {
    const el = dom.getHiddenInputEl(ctx);
    if (!el)
      return;
    dispatchInputValueEvent(el, ctx.valueAsString);
  }
};

// src/tags-input.connect.ts
function connect(state, send, normalize = normalizeProp) {
  const isInteractive = state.context.isInteractive;
  const isDisabled = state.context.disabled;
  const isReadonly = state.context.readonly;
  const isInvalid = state.context.invalid || state.context.isOverflowing;
  const messages = state.context.messages;
  const isInputFocused = state.hasTag("focused");
  const isEditingTag = state.matches("editing:tag");
  const isEmpty = state.context.count === 0;
  return {
    isEmpty,
    inputValue: state.context.trimmedInputValue,
    value: state.context.value,
    count: state.context.count,
    valueAsString: state.context.valueAsString,
    isAtMax: state.context.isAtMax,
    setValue(value) {
      send({ type: "SET_VALUE", value });
    },
    clearAll() {
      send("CLEAR_ALL");
    },
    addValue(value) {
      send({ type: "ADD_TAG", value });
    },
    deleteValue(id) {
      send({ type: "DELETE_TAG", id });
    },
    setInputValue(value) {
      send({ type: "SET_INPUT_VALUE", value });
    },
    clearInputValue() {
      send({ type: "SET_INPUT_VALUE", value: "" });
    },
    focus() {
      var _a;
      (_a = dom.getInputEl(state.context)) == null ? void 0 : _a.focus();
    },
    rootProps: normalize.element({
      dir: state.context.dir,
      "data-part": "root",
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadonly),
      "data-disabled": dataAttr(isDisabled),
      "data-focus": dataAttr(isInputFocused),
      "data-empty": dataAttr(isEmpty),
      id: dom.getRootId(state.context),
      onPointerDown() {
        if (!isInteractive)
          return;
        send("POINTER_DOWN");
      }
    }),
    labelProps: normalize.label({
      "data-part": "label",
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadonly),
      id: dom.getLabelId(state.context),
      htmlFor: dom.getInputId(state.context)
    }),
    controlProps: normalize.element({
      id: dom.getControlId(state.context),
      "data-part": "control",
      tabIndex: isReadonly ? 0 : void 0,
      "data-disabled": dataAttr(isDisabled),
      "data-readonly": dataAttr(isReadonly),
      "data-invalid": dataAttr(isInvalid),
      "data-focus": dataAttr(isInputFocused)
    }),
    inputProps: normalize.input({
      "data-part": "input",
      "data-invalid": dataAttr(isInvalid),
      "aria-invalid": isInvalid,
      "data-readonly": dataAttr(isReadonly),
      maxLength: state.context.maxLength,
      id: dom.getInputId(state.context),
      value: state.context.inputValue,
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "none",
      disabled: isDisabled || isReadonly,
      onChange(event) {
        const evt = getNativeEvent(event);
        if (evt.isComposing || evt.inputType === "insertFromPaste")
          return;
        send({ type: "TYPE", value: event.target.value });
      },
      onFocus() {
        send("FOCUS");
      },
      onBlur(event) {
        const isValidBlur = validateBlur(event, {
          exclude: dom.getRootEl(state.context)
        });
        if (isValidBlur) {
          send("BLUR");
        }
      },
      onPaste(event) {
        const value = event.clipboardData.getData("text/plain");
        send({ type: "PASTE", value });
      },
      onKeyDown(event) {
        const evt = getNativeEvent(event);
        if (evt.isComposing)
          return;
        const attr = matchAttr(event.currentTarget);
        const isCombobox = attr.is("role", "combobox");
        const isExpanded = attr.is("aria-expanded", "true");
        const keyMap = {
          ArrowDown() {
            send("ARROW_DOWN");
          },
          ArrowLeft() {
            if (isCombobox && isExpanded)
              return;
            send("ARROW_LEFT");
          },
          ArrowRight() {
            if (state.context.focusedId) {
              event.preventDefault();
            }
            if (isCombobox && isExpanded)
              return;
            send("ARROW_RIGHT");
          },
          Escape(event2) {
            event2.preventDefault();
            send("ESCAPE");
          },
          Backspace() {
            send("BACKSPACE");
          },
          Delete() {
            send("DELETE");
          },
          Enter(event2) {
            event2.preventDefault();
            send("ENTER");
          }
        };
        const key = getEventKey(event, state.context);
        const exec = keyMap[key];
        if (exec) {
          exec == null ? void 0 : exec(event);
          return;
        }
        const isDelimiter = event.key === state.context.delimiter;
        if (isDelimiter) {
          event.preventDefault();
          send("DELIMITER_KEY");
        }
      }
    }),
    hiddenInputProps: normalize.input({
      "data-part": "hidden-input",
      type: "text",
      hidden: true,
      name: state.context.name,
      id: dom.getHiddenInputId(state.context),
      defaultValue: state.context.valueAsString
    }),
    getTagProps(options) {
      const { value } = options;
      const id = dom.getTagId(state.context, options);
      return normalize.element({
        "data-part": "tag",
        id,
        hidden: isEditingTag ? state.context.editedId === id : false,
        "data-value": value,
        "data-disabled": dataAttr(isDisabled),
        "data-selected": dataAttr(id === state.context.focusedId),
        onPointerDown(event) {
          if (!isInteractive)
            return;
          event.preventDefault();
          send({ type: "POINTER_DOWN_TAG", id });
        },
        onDoubleClick() {
          if (!isInteractive)
            return;
          send({ type: "DOUBLE_CLICK_TAG", id });
        }
      });
    },
    getTagInputProps(options) {
      const id = dom.getTagId(state.context, options);
      const active = state.context.editedId === id;
      return normalize.input({
        "data-part": "tag-input",
        "aria-label": messages.tagEdited(options.value),
        "aria-hidden": true,
        disabled: isDisabled,
        id: dom.getTagInputId(state.context, options),
        type: "text",
        tabIndex: -1,
        hidden: isEditingTag ? !active : true,
        value: active ? state.context.editedTagValue : "",
        onChange(event) {
          send({ type: "TAG_INPUT_TYPE", value: event.target.value });
        },
        onBlur(event) {
          send({ type: "TAG_INPUT_BLUR", target: event.relatedTarget });
        },
        onKeyDown(event) {
          const keyMap = {
            Enter() {
              send("TAG_INPUT_ENTER");
            },
            Escape() {
              send("TAG_INPUT_ESCAPE");
            }
          };
          const exec = keyMap[event.key];
          if (exec) {
            event.preventDefault();
            exec(event);
          }
        }
      });
    },
    getTagDeleteButtonProps(options) {
      const id = dom.getTagId(state.context, options);
      return normalize.button({
        "data-part": "delete-button",
        id: dom.getTagDeleteBtnId(state.context, options),
        type: "button",
        disabled: isDisabled,
        "aria-label": messages.deleteTagButtonLabel(options.value),
        tabIndex: -1,
        onPointerDown(event) {
          if (!isInteractive) {
            event.preventDefault();
          }
        },
        onPointerMove(event) {
          if (!isInteractive)
            return;
          dom.setHoverIntent(event.currentTarget);
        },
        onPointerLeave(event) {
          if (!isInteractive)
            return;
          dom.clearHoverIntent(event.currentTarget);
        },
        onClick() {
          if (!isInteractive)
            return;
          send({ type: "DELETE_TAG", id });
        }
      });
    },
    clearButtonProps: normalize.button({
      "data-part": "clear-button",
      id: dom.getClearButtonId(state.context),
      type: "button",
      "data-readonly": dataAttr(isReadonly),
      disabled: isDisabled,
      "aria-label": messages.clearButtonLabel,
      hidden: isEmpty,
      onClick() {
        if (!isInteractive)
          return;
        send("CLEAR_ALL");
      }
    })
  };
}

// src/tags-input.machine.ts
import { createMachine, guards, ref } from "@zag-js/core";
var { and, not, or } = guards;
function machine(ctx = {}) {
  return createMachine({
    id: "tags-input",
    initial: "unknown",
    context: __spreadProps(__spreadValues({
      log: { current: null, prev: null },
      uid: "",
      inputValue: "",
      editedTagValue: "",
      focusedId: null,
      editedId: null,
      initialValue: [],
      value: [],
      dir: "ltr",
      max: Infinity,
      liveRegion: null,
      blurBehavior: void 0,
      addOnPaste: false,
      allowEditTag: true,
      validate: () => true,
      delimiter: ","
    }, ctx), {
      messages: __spreadValues({
        clearButtonLabel: "Clear all tags",
        deleteTagButtonLabel: (value) => `Delete tag ${value}`,
        tagAdded: (value) => `Added tag ${value}`,
        tagsPasted: (values) => `Pasted ${values.length} tags`,
        tagEdited: (value) => `Editing tag ${value}. Press enter to save or escape to cancel.`,
        tagUpdated: (value) => `Tag update to ${value}`,
        tagDeleted: (value) => `Tag ${value} deleted`,
        tagSelected: (value) => `Tag ${value} selected. Press enter to edit, delete or backspace to remove.`
      }, ctx.messages)
    }),
    computed: {
      count: (ctx2) => ctx2.value.length,
      valueAsString: (ctx2) => JSON.stringify(ctx2.value),
      trimmedInputValue: (ctx2) => ctx2.inputValue.trim(),
      isInteractive: (ctx2) => !(ctx2.readonly || ctx2.disabled),
      isAtMax: (ctx2) => ctx2.count === ctx2.max,
      isOverflowing: (ctx2) => ctx2.count > ctx2.max
    },
    watch: {
      focusedId: ["invokeOnHighlight", "logFocused"],
      isOverflowing: "invokeOnInvalid",
      value: ["invokeOnChange", "dispatchChangeEvent"],
      log: "announceLog"
    },
    activities: ["trackFormReset"],
    exit: ["removeLiveRegion", "clearLog"],
    on: {
      DOUBLE_CLICK_TAG: {
        guard: "allowEditTag",
        target: "editing:tag",
        actions: ["setEditedId", "initializeEditedTagValue"]
      },
      POINTER_DOWN_TAG: {
        guard: not("isTagFocused"),
        target: "navigating:tag",
        actions: ["focusTag", "focusInput"]
      },
      SET_INPUT_VALUE: {
        actions: ["setInputValue"]
      },
      SET_VALUE: {
        actions: ["setValue"]
      },
      DELETE_TAG: {
        actions: ["deleteTag"]
      },
      CLEAR_ALL: {
        actions: ["clearTags", "focusInput"]
      },
      ADD_TAG: {
        guard: and(or(not("isAtMax"), "allowOverflow"), not("isInputValueEmpty")),
        actions: ["addTag", "clearInputValue"]
      },
      EXT_BLUR: [
        { guard: "addOnBlur", actions: "raiseAddTagEvent" },
        { guard: "clearOnBlur", actions: "clearInputValue" }
      ]
    },
    states: {
      unknown: {
        on: {
          SETUP: [
            {
              guard: "autoFocus",
              target: "focused:input",
              actions: ["setupDocument", "checkValue"]
            },
            { target: "idle", actions: ["setupDocument", "checkValue"] }
          ]
        }
      },
      idle: {
        on: {
          FOCUS: "focused:input",
          POINTER_DOWN: {
            guard: not("hasFocusedId"),
            target: "focused:input"
          }
        }
      },
      "focused:input": {
        tags: ["focused"],
        entry: ["focusInput", "clearFocusedId"],
        on: {
          TYPE: {
            actions: "setInputValue"
          },
          BLUR: [
            {
              guard: "addOnBlur",
              target: "idle",
              actions: "raiseAddTagEvent"
            },
            {
              guard: "clearOnBlur",
              target: "idle",
              actions: "clearInputValue"
            },
            { target: "idle" }
          ],
          ENTER: {
            actions: ["raiseAddTagEvent"]
          },
          DELIMITER_KEY: {
            actions: ["raiseAddTagEvent"]
          },
          ARROW_LEFT: {
            guard: and("hasTags", "isInputCaretAtStart"),
            target: "navigating:tag",
            actions: "focusLastTag"
          },
          BACKSPACE: {
            target: "navigating:tag",
            guard: and("hasTags", "isInputCaretAtStart"),
            actions: "focusLastTag"
          },
          PASTE: {
            guard: "addOnPaste",
            actions: ["setInputValue", "addTagFromPaste"]
          }
        }
      },
      "navigating:tag": {
        tags: ["focused"],
        on: {
          ARROW_RIGHT: [
            {
              guard: and("hasTags", "isInputCaretAtStart", not("isLastTagFocused")),
              actions: "focusNextTag"
            },
            { target: "focused:input" }
          ],
          ARROW_LEFT: {
            actions: "focusPrevTag"
          },
          BLUR: {
            target: "idle",
            actions: "clearFocusedId"
          },
          ENTER: {
            guard: "allowEditTag",
            target: "editing:tag",
            actions: ["setEditedId", "initializeEditedTagValue", "focusEditedTagInput"]
          },
          ARROW_DOWN: "focused:input",
          ESCAPE: "focused:input",
          TYPE: {
            target: "focused:input",
            actions: "setInputValue"
          },
          BACKSPACE: [
            {
              guard: "isFirstTagFocused",
              actions: ["deleteFocusedTag", "focusFirstTag"]
            },
            {
              actions: ["deleteFocusedTag", "focusPrevTag"]
            }
          ],
          DELETE: {
            actions: ["deleteFocusedTag", "focusTagAtIndex"]
          }
        }
      },
      "editing:tag": {
        tags: ["editing", "focused"],
        entry: "focusEditedTagInput",
        activities: ["autoResizeTagInput"],
        on: {
          TAG_INPUT_TYPE: {
            actions: "setEditedTagValue"
          },
          TAG_INPUT_ESCAPE: {
            target: "navigating:tag",
            actions: ["clearEditedTagValue", "focusInput", "clearEditedId", "focusTagAtIndex"]
          },
          TAG_INPUT_BLUR: [
            {
              guard: "isInputRelatedTarget",
              target: "navigating:tag",
              actions: ["clearEditedTagValue", "clearFocusedId", "clearEditedId"]
            },
            {
              target: "idle",
              actions: ["clearEditedTagValue", "clearFocusedId", "clearEditedId", "raiseExtBlurEvent"]
            }
          ],
          TAG_INPUT_ENTER: {
            target: "navigating:tag",
            actions: ["submitEditedTagValue", "focusInput", "clearEditedId", "focusTagAtIndex", "invokeOnTagUpdate"]
          }
        }
      }
    }
  }, {
    guards: {
      isInputRelatedTarget: (ctx2, evt) => evt.relatedTarget === dom.getInputEl(ctx2),
      isAtMax: (ctx2) => ctx2.isAtMax,
      hasFocusedId: (ctx2) => ctx2.focusedId !== null,
      isTagFocused: (ctx2, evt) => ctx2.focusedId === evt.id,
      isFirstTagFocused: (ctx2) => {
        var _a;
        return ((_a = dom.getFirstEl(ctx2)) == null ? void 0 : _a.id) === ctx2.focusedId;
      },
      isLastTagFocused: (ctx2) => {
        var _a;
        return ((_a = dom.getLastEl(ctx2)) == null ? void 0 : _a.id) === ctx2.focusedId;
      },
      isInputValueEmpty: (ctx2) => ctx2.trimmedInputValue.length === 0,
      hasTags: (ctx2) => ctx2.value.length > 0,
      allowOverflow: (ctx2) => !!ctx2.allowOverflow,
      autoFocus: (ctx2) => !!ctx2.autoFocus,
      addOnBlur: (ctx2) => ctx2.blurBehavior === "add",
      clearOnBlur: (ctx2) => ctx2.blurBehavior === "clear",
      addOnPaste: (ctx2) => !!ctx2.addOnPaste,
      allowEditTag: (ctx2) => !!ctx2.allowEditTag,
      isInputCaretAtStart(ctx2) {
        const input = dom.getInputEl(ctx2);
        if (!input)
          return false;
        try {
          return input.selectionStart === 0 && input.selectionEnd === 0;
        } catch (e) {
          return input.value === "";
        }
      }
    },
    activities: {
      trackFormReset(ctx2) {
        let cleanup;
        raf(() => {
          cleanup = trackFormReset(dom.getHiddenInputEl(ctx2), () => {
            ctx2.value = ctx2.initialValue;
          });
        });
        return cleanup;
      },
      autoResizeTagInput(ctx2) {
        if (!ctx2.editedTagValue || ctx2.__index == null || !ctx2.allowEditTag)
          return;
        const input = dom.getTagInputEl(ctx2, { value: ctx2.editedTagValue, index: ctx2.__index });
        return autoResizeInput(input);
      }
    },
    actions: {
      raiseAddTagEvent(_, __, { self }) {
        self.send("ADD_TAG");
      },
      raiseExtBlurEvent(_, __, { self }) {
        self.send("EXT_BLUR");
      },
      invokeOnHighlight(ctx2) {
        var _a;
        const value = dom.getFocusedTagValue(ctx2);
        (_a = ctx2.onHighlight) == null ? void 0 : _a.call(ctx2, { value });
      },
      invokeOnTagUpdate(ctx2) {
        var _a;
        if (!ctx2.__index)
          return;
        const value = ctx2.value[ctx2.__index];
        (_a = ctx2.onTagUpdate) == null ? void 0 : _a.call(ctx2, { value, index: ctx2.__index });
      },
      invokeOnChange(ctx2) {
        var _a;
        (_a = ctx2.onChange) == null ? void 0 : _a.call(ctx2, { values: ctx2.value });
      },
      dispatchChangeEvent(ctx2) {
        dom.dispatchInputEvent(ctx2);
      },
      setupDocument(ctx2, evt) {
        ctx2.uid = evt.id;
        if (evt.doc)
          ctx2.doc = ref(evt.doc);
        if (evt.root)
          ctx2.rootNode = ref(evt.root);
        nextTick(() => {
          ctx2.liveRegion = createLiveRegion({
            level: "assertive",
            document: ctx2.doc
          });
        });
      },
      focusNextTag(ctx2) {
        if (!ctx2.focusedId)
          return;
        const next = dom.getNextEl(ctx2, ctx2.focusedId);
        if (next)
          ctx2.focusedId = next.id;
      },
      focusFirstTag(ctx2) {
        raf(() => {
          var _a;
          const first = (_a = dom.getFirstEl(ctx2)) == null ? void 0 : _a.id;
          if (first)
            ctx2.focusedId = first;
        });
      },
      focusLastTag(ctx2) {
        const last = dom.getLastEl(ctx2);
        if (last)
          ctx2.focusedId = last.id;
      },
      focusPrevTag(ctx2) {
        if (!ctx2.focusedId)
          return;
        const prev = dom.getPrevEl(ctx2, ctx2.focusedId);
        if (prev)
          ctx2.focusedId = prev.id;
      },
      focusTag(ctx2, evt) {
        ctx2.focusedId = evt.id;
      },
      focusTagAtIndex(ctx2) {
        raf(() => {
          if (ctx2.__index == null)
            return;
          const el = dom.getElAtIndex(ctx2, ctx2.__index);
          if (el) {
            ctx2.focusedId = el.id;
            ctx2.__index = void 0;
          }
        });
      },
      deleteTag(ctx2, evt) {
        const index = dom.getIndexOfId(ctx2, evt.id);
        const value = ctx2.value[index];
        ctx2.log.prev = ctx2.log.current;
        ctx2.log.current = { type: "delete", value };
        ctx2.value.splice(index, 1);
      },
      deleteFocusedTag(ctx2) {
        if (!ctx2.focusedId)
          return;
        const index = dom.getIndexOfId(ctx2, ctx2.focusedId);
        ctx2.__index = index;
        const value = ctx2.value[index];
        ctx2.log.prev = ctx2.log.current;
        ctx2.log.current = { type: "delete", value };
        ctx2.value.splice(index, 1);
      },
      setEditedId(ctx2, evt) {
        var _a;
        ctx2.editedId = (_a = evt.id) != null ? _a : ctx2.focusedId;
        ctx2.__index = dom.getIndexOfId(ctx2, ctx2.editedId);
      },
      clearEditedId(ctx2) {
        ctx2.editedId = null;
      },
      clearEditedTagValue(ctx2) {
        ctx2.editedTagValue = "";
      },
      setEditedTagValue(ctx2, evt) {
        ctx2.editedTagValue = evt.value;
      },
      submitEditedTagValue(ctx2) {
        var _a;
        if (!ctx2.editedId)
          return;
        const index = dom.getIndexOfId(ctx2, ctx2.editedId);
        ctx2.value[index] = (_a = ctx2.editedTagValue) != null ? _a : "";
        ctx2.log.prev = ctx2.log.current;
        ctx2.log.current = { type: "update", value: ctx2.editedTagValue };
      },
      initializeEditedTagValue(ctx2) {
        if (!ctx2.editedId)
          return;
        const index = dom.getIndexOfId(ctx2, ctx2.editedId);
        ctx2.editedTagValue = ctx2.value[index];
      },
      focusEditedTagInput(ctx2) {
        raf(() => {
          var _a;
          (_a = dom.getEditInputEl(ctx2)) == null ? void 0 : _a.select();
        });
      },
      setInputValue(ctx2, evt) {
        ctx2.inputValue = evt.value;
      },
      clearFocusedId(ctx2) {
        ctx2.focusedId = null;
      },
      focusInput(ctx2) {
        raf(() => {
          var _a;
          (_a = dom.getInputEl(ctx2)) == null ? void 0 : _a.focus();
        });
      },
      clearInputValue(ctx2) {
        ctx2.inputValue = "";
      },
      addTag(ctx2, evt) {
        var _a, _b, _c;
        const value = (_a = evt.value) != null ? _a : ctx2.trimmedInputValue;
        const guard = (_b = ctx2.validate) == null ? void 0 : _b.call(ctx2, { inputValue: value, values: ctx2.value });
        if (guard) {
          ctx2.value.push(value);
          ctx2.log.prev = ctx2.log.current;
          ctx2.log.current = { type: "add", value };
        } else {
          (_c = ctx2.onInvalid) == null ? void 0 : _c.call(ctx2, { reason: "invalidTag" });
        }
      },
      addTagFromPaste(ctx2) {
        raf(() => {
          var _a, _b;
          const value = ctx2.trimmedInputValue;
          const guard = (_a = ctx2.validate) == null ? void 0 : _a.call(ctx2, { inputValue: value, values: ctx2.value });
          if (guard) {
            const trimmedValue = ctx2.delimiter ? value.split(ctx2.delimiter).map((v) => v.trim()) : [value];
            ctx2.value.push(...trimmedValue);
            ctx2.log.prev = ctx2.log.current;
            ctx2.log.current = { type: "paste", values: trimmedValue };
          } else {
            (_b = ctx2.onInvalid) == null ? void 0 : _b.call(ctx2, { reason: "invalidTag" });
          }
          ctx2.inputValue = "";
        });
      },
      clearTags(ctx2) {
        ctx2.value = [];
        ctx2.log.prev = ctx2.log.current;
        ctx2.log.current = { type: "clear" };
      },
      checkValue(ctx2) {
        ctx2.initialValue = ctx2.value.slice();
      },
      setValue(ctx2, evt) {
        ctx2.value = evt.value;
      },
      removeLiveRegion(ctx2) {
        var _a;
        (_a = ctx2.liveRegion) == null ? void 0 : _a.destroy();
      },
      invokeOnInvalid(ctx2) {
        var _a;
        if (ctx2.isOverflowing) {
          (_a = ctx2.onInvalid) == null ? void 0 : _a.call(ctx2, { reason: "rangeOverflow" });
        }
      },
      clearLog(ctx2) {
        ctx2.log = { prev: null, current: null };
      },
      logFocused(ctx2) {
        if (!ctx2.focusedId)
          return;
        const index = dom.getIndexOfId(ctx2, ctx2.focusedId);
        ctx2.log.prev = ctx2.log.current;
        ctx2.log.current = { type: "select", value: ctx2.value[index] };
      },
      announceLog(ctx2) {
        if (!ctx2.log.current || ctx2.liveRegion == null)
          return;
        const region = ctx2.liveRegion;
        const { current, prev } = ctx2.log;
        let msg;
        switch (current.type) {
          case "add":
            msg = ctx2.messages.tagAdded(current.value);
            break;
          case "delete":
            msg = ctx2.messages.tagDeleted(current.value);
            break;
          case "update":
            msg = ctx2.messages.tagUpdated(current.value);
            break;
          case "paste":
            msg = ctx2.messages.tagsPasted(current.values);
            break;
          case "select":
            msg = ctx2.messages.tagSelected(current.value);
            if ((prev == null ? void 0 : prev.type) === "delete") {
              msg = `${ctx2.messages.tagDeleted(prev.value)}. ${msg}`;
            } else if ((prev == null ? void 0 : prev.type) === "update") {
              msg = `${ctx2.messages.tagUpdated(prev.value)}. ${msg}`;
            }
            break;
          default:
            break;
        }
        if (msg)
          region.announce(msg);
      }
    },
    hookSync: true
  });
}
export {
  connect,
  machine
};
//# sourceMappingURL=index.mjs.map
